import styled, { css } from 'styled-components';
import searchBg from '../../img/search.svg';
import start from '../../img/House.svg';
import startHover from '../../img/HouseHover.svg';
import courses from '../../img/GraduationCap.svg';
import coursesHover from '../../img/GraduationCapHover.svg';
import user from '../../img/UserCircle.svg';
import userHover from '../../img/UserCircleHover.svg';
import questions from '../../img/BookOpenText.svg';
import questionsHover from '../../img/BookOpenTextHover.svg';
import cashback from '../../img/Cardholder.svg';
import cashbackHover from '../../img/CardholderHover.svg';
import support from '../../img/Lifebuoy.svg';
import supportHover from '../../img/LifebuoyHover.svg';
import faq from '../../img/ChatCircleDots.svg';
import faqHover from '../../img/ChatCircleDotsHover.svg';
import logout from '../../img/SignOut.svg';
import logoutHover from '../../img/SignOutHover.svg';
import podcast from '../../img/headset.svg';
import podcastHover from '../../img/headset-hover.svg';
import gabaritoro from '../../img/FileText.svg';
import gabaritoroHover from '../../img/FileTextHover.svg';
import notifications from '../../img/Bell.svg';
import notificationsHover from '../../img/BellHover.svg';
import appQuiz from '../../img/appQuiz.svg';
import appQuizHover from '../../img/appQuizHover.svg';
import more from '../../img/DotsThreeOutline.svg';
import supportLifetime from '../../img/supportTimelife.svg';
import supportLifetimeHover from '../../img/supportTimelifeHover.svg';

type TBackgrounds = {
  [key: string]: {
    normal: string;
    hover: string;
  };
};

type TItem = {
  id: string;
  border?: boolean;
};

const backgrounds: TBackgrounds = {
  start: { normal: start, hover: startHover },
  courses: { normal: courses, hover: coursesHover },
  user: { normal: user, hover: userHover },
  questions: { normal: questions, hover: questionsHover },
  cashback: { normal: cashback, hover: cashbackHover },
  support: { normal: support, hover: supportHover },
  'lifetime-support': { normal: supportLifetime, hover: supportLifetimeHover },
  faq: { normal: faq, hover: faqHover },
  logout: { normal: logout, hover: logoutHover },
  podcast: { normal: podcast, hover: podcastHover },
  gabaritoro: { normal: gabaritoro, hover: gabaritoroHover },
  contracts: { normal: gabaritoro, hover: gabaritoroHover },
  notifications: { normal: notifications, hover: notificationsHover },
  more: { normal: more, hover: more },
  appQuiz: { normal: appQuiz, hover: appQuizHover },
  // TODO: placeholder — trocar pelo ícone definitivo do IndicaToro (layout aprovado) quando disponível
  indicatoro: { normal: cashback, hover: cashbackHover },
};

export const Container = styled.div`
  position: fixed;
  top: 0;
  z-index: 100000;
  left: 0;
  right: 0;

  display: flex;
  justify-content: space-between;
  algin-items: center;
  padding: 0 30px;
  height: 74px;
  background: #fff;
  border-bottom: 1px solid #efefef;

  @media (max-width: 768px) {
    z-index: 100000;
    height: 50px;
  }
`;

export const Content = styled.div`
  display: flex;
  align-self: center;
  algin-items: center;
  gap: 194px;

  fieldset {
    display: flex;
    border-radius: 10px;
    algin-items: center;
    padding-left: 51px;
    width: 360px;
    height: 44px;
    background: url(${searchBg}) no-repeat #f7f7f7 20px center;
  }

  legend {
    display: none;
  }

  label {
    display: none;
  }

  input {
    border: none;
    width: 280px;
    height: 24px;
    align-self: center;
    font-size: 16px;
    background: none;
    outline: none;
    font-family: 'Manrope', sans-serif;
    font-optical-sizing: auto;
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
    letter-spacing: 0.48px;
  }

  input::placeholder {
    color: #a4a4a4;
    opacity: 1;
  }

  input::-ms-input-placeholder {
    color: #a4a4a4;
  }
`;

export const UserContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 41px;
  height: 41px;
  align-self: center;
  justify-content: space-between;

  cursor: pointer;

  border-radius: 50%;
  border: 2px solid #fff;

  transition: all 0.2s ease-in-out;

  &:hover {
    border: 2px solid #5768ff;
  }

  > div {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 50%;
    overflow: hidden;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const NameLetterIcon = styled.p`
  font-family: Manrope, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  margin: 0 auto;

  color: #5768ff;

  background: #f7f7f7;
  width: 41px;
  height: 37px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Item = styled.div<TItem>`
  margin-bottom: 4px;
  padding: 0 30px;
  /* height: 50px; */
  color: #a4a4a4;
  cursor: pointer;
  display: flex;
  gap: 10px;
  display: none;
  position: relative;

  @media (max-width: 768px) {
    padding: 0;
    display: flex;
  }

  a,
  span {
    display: flex;
    width: 100%;
    align-self: center;
    justify-content: space-between;
    align-items: center;
    color: #a4a4a4;
    padding-left: 31px;
    height: 30px;
    line-height: 30px;
    background: no-repeat 0 center;
    transition: all 0.3s ease-in-out;

    strong {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 35px;
      height: 35px;
      border-radius: 50%;
      background-color: #d81e5b;
      text-align: center;
      color: #fff;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      transition: all 0.3s ease-in-out;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    @media (max-width: 768px) {
      text-indent: -5000em;
      position: relative;

      strong {
        text-indent: 0;
        position: absolute;
        right: 3px;
        width: 16px;
        height: 16px;
        font-size: 10px;
        line-height: 16px;
      }
    }
  }

  &:hover {
    @media (min-width: 769px) {
      border-left: 3px solid #5768ff;
      padding-left: 27px;
      color: #5768ff;
    }

    a,
    span {
      color: #5768ff;

      strong {
        background-color: #5768ff;
      }
    }
  }

  ${({ id }) =>
    backgrounds[id] &&
    css`
      a,
      span {
        background-image: url(${backgrounds[id].normal});
      }

      &:hover {
        a,
        span {
          background-image: url(${backgrounds[id].hover});
        }
      }
    `}

  ${({ border }) =>
    border &&
    css`
      @media (min-width: 769px) {
        position: relative;
        margin-top: 12px;

        &::before {
          content: '';
          position: absolute;
          top: -8px;
          left: 0;
          border: 1px solid #efefef;
          width: 100%;
        }
      }
    `}

  strong {
    position: absolute;
    color: #fff;
    background-color: #d81e5b;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0px;
    left: 10px;
    font-size: 10px;
    font-weight: normal;
    width: 14px;
    height: 14px;
  }

  &#lifetime-support {
    a,
    span {
      color: #f3cf58;
      font-weight: bolder;
    }
  }
`;

export const NotificationsItemsArea = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  gap: 20px;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const ItemsArea = styled.div`
  width: 187px;
  height: fit-content;
  max-height: 400px;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  top: 65px;
  right: 20px;
  border-radius: 10px;
  padding: 10px;
  overflow-y: auto;

  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  display: none;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    gap: 5px;
  }

  /* Override Item styles when inside ItemsArea */
  ${Item} {
    display: flex !important;
    padding: 5px 10px;
    height: 40px;
    border-radius: 5px;
    transition: background-color 0.2s ease;
    margin-bottom: 0;

    &:hover {
      background-color: #f7f7f7;
      border-left: none;
      padding-left: 10px;
    }

    a,
    span {
      padding-left: 25px;
      font-size: 14px;

      @media (max-width: 768px) {
        text-indent: 0;
      }
    }
  }
`;
